
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tattoo-font-generator",
      function () {
        return require("private-next-pages/tattoo-font-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tattoo-font-generator"])
      });
    }
  